<div class="toast-container position-fixed p-4" [ngClass]="positionClasses">
    @for (toast of toasts; track toast; let last = $last) {
        <fdx-toast [toast]="toast" [class.mb-4]="!last"/>
    }
</div>
